import axios from "axios";
import { toast } from "react-toastify";

/**
 * @description Sends a Get request to api
 * @param {String} route
 * @example "/api/route"
 * @returns Promise<any>
 */

let Get = async (route, accessToken, showAlert = true) => {
  const options = accessToken
    ? {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    : {
        headers: {
          Accept: "application/json",
        },
      };
  try {
    const response = await axios.get(route, options);
    return response;
  } catch (error) {
    console.log("error from Post",error)
    let errorMessage = "";
    Array.isArray(error?.response?.data?.message)
      ? error?.response?.data?.message?.map(
          (item) => (errorMessage = `${errorMessage} • ${item} \n`)
        )
      : (errorMessage = error?.response?.data?.message);

      console.log("error ==>> ",errorMessage)
    if (showAlert == true) {
      if (error.message === "Network Error") {
        toast.error(`${error.message} : Please Check Your Network Connection`, {
          position: "top-center",
        });
      } else {
        toast.error(errorMessage, {
          position: "top-center",
        });
      }
    }
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 * @returns Promise<any>
 */

let Post = async (route, data, headers) => {
  try {
    return await axios.post(route, data, headers);
  } catch (error) {
    console.log("error from Post", error);
    let errorMessage = "";

  
      Array.isArray(Object?.values(error?.response?.data?.errors))
        ? Object?.values(error?.response?.data?.errors)?.map(
            (item) => (errorMessage = `${errorMessage} • ${item.join(" ")} \n`)
          )
        : (errorMessage = error?.response?.data?.headers?.message);
        console.log("errorMessage ==>> ",errorMessage)
    if (error.message === "Network Error") {
      toast.error(`${error.message} : Please Check Your Network Connection`, {
        position: "top-center",
      });
    } else {
      toast.error(errorMessage, {
        position: "top-center",
      });
      // store.dispatch(logOutRequest());
    }
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */

let Patch = async (route, data, headers) => {
  try {
    return await axios.patch(route, data, headers);
  } catch (error) {
    let errorMessage = "";
    Array.isArray(error?.response?.data?.message)
      ? error?.response?.data?.message?.map(
          (item) => (errorMessage = `${errorMessage} • ${item} \n`)
        )
      : (errorMessage = error?.response?.data?.message);
    if (error.message === "Network Error") {
      toast.error(`${error.message} : Please Check Your Network Connection`, {
        position: "top-center",
      });
    } else {
      toast.error(errorMessage, {
        position: "top-center",
      });
    }
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */

let Put = async (route, data, headers) => {
  try {
    return await axios.put(route, data, headers);
  } catch (error) {
    let errorMessage = "";
    Array.isArray(error?.response?.data?.message)
      ? error?.response?.data?.message?.map(
          (item) => (errorMessage = `${errorMessage} • ${item} \n`)
        )
      : (errorMessage = error?.response?.data?.message);
    if (error.message === "Network Error") {
      toast.error(`${error.message} : Please Check Your Network Connection`, {
        position: "top-center",
      });
    } else {
      toast.error(errorMessage, {
        position: "top-center",
      });
    }
  }
};

/**
 * @description Sends a Delete request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */

let Delete = async (route, data, headers) => {
  try {
    return data == null
      ? await axios.delete(route, headers)
      : await axios.delete(route, data, headers);
  } catch (error) {
    let errorMessage = "";
    Array.isArray(error?.response?.data?.message)
      ? error?.response?.data?.message?.map(
          (item) => (errorMessage = `${errorMessage} • ${item} \n`)
        )
      : (errorMessage = error?.response?.data?.message);
    if (error.message === "Network Error") {
      toast.error(`${error.message} : Please Check Your Network Connection`, {
        position: "top-center",
      });
    } else {
      toast.error(errorMessage, {
        position: "top-center",
      });
    }
  }
};
export { Post, Put, Get, Patch, Delete };
